import { Routes } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { LoginComponent } from './login/login.component';
import { authGuard } from './core/guards/auth.guard';
import { adminGuard } from './core/guards/admin.guard';

export const APP_ROUTES: Routes = [
  {
    path: 'login',
    component: LoginComponent,
  },
  {
    path: '',
    component: LayoutComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'selection',
        loadChildren: () => import('./features/selection/new-selection.module').then((m) => m.SelectionModule),
      },
      {
        path: 'saved',
        loadChildren: () => import('./features/saved-selections/saved-selections.module').then((m) => m.SavedSelectionsModule),
      },
      {
        path: 'admin',
        canActivate: [adminGuard],
        loadChildren: () => import('./features/admin/admin.module').then((m) => m.AdminModule),
      },
      {
        path: '',
        redirectTo: 'selection',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/selection',
  },
];
